<div class="icon-select-container">
  <h4 translate="SETTINGS.MENU.EDIT.ICON"></h4>
  <div class="icon-edit-container">
    @if (displayIcon && !showIconSelect) {
      <gb-icon class="icon" [icon]="displayIcon" [library]="Iconlibrary.material"></gb-icon>
    }
    @if (!showIconSelect) {
      <button
        class="edit-icon-button"
        type="button"
        mat-stroked-button
        (click)="toggleShowIconSelect()"
        translate="SETTINGS.MENU.EDIT.EDIT_ICON"
      ></button>
    }
  </div>

  @if (showIconSelect) {
    <div class="icon-select" #iconSelect>
      <div class="search-close-container">
        <button mat-button (click)="toggleShowIconSelect()">
          <gb-icon icon="arrow-back"></gb-icon>
        </button>
        <mat-form-field>
          <mat-label translate="SETTINGS.MENU.EDIT.ICON_SEARCH_LABEL"> </mat-label>
          <input matInput [(ngModel)]="searchValue" />
        </mat-form-field>
      </div>
      <div class="icon-list-container">
        @for (icon of icons | filterByTag: searchValue || ''; track icon) {
          <div class="icon-container" (click)="onClickIcon(icon.name)">
            <gb-icon [icon]="icon.name" [library]="Iconlibrary.material"></gb-icon>
          </div>
        }
      </div>
    </div>
  }
</div>
